<template>
    <table class="table table-striped" v-if="projects">
        <thead>
        <tr>
            <th>Nummer</th>
            <th>Projektleitung</th>
            <th>Kurztitel</th>
            <th>Titel</th>
            <th class="text-center">Programm</th>
            <th class="text-center">Version</th>
            <th class="text-right">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="project in projects">
            <td>{{project.number}}</td>
            <td>{{project.lead}}</td>
            <td>{{project.shortTitle.text}}</td>
            <td>{{project.name.text}}</td>
            <td class="text-center">{{project.program}}</td>
            <td class="text-center">{{project.version}}</td>
            <td class="text-right">
                <router-link v-if="type !== 'umbrella'" :to="{ name: 'project-edit', params: { projectId: project.id }}"><i
                        class="fa fa-edit fa-fw"></i></router-link>
                <router-link v-else :to="{ name: 'umbrella-project-edit', params: { projectId: project.id }}"><i
                        class="fa fa-edit fa-fw"></i></router-link>
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
export default {
  props: ["projects", "type"],
  computed: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjectList.vue